/**
 * 书架渲染辅助函数模块
 */

export function buildCollectionShelfHeaderHtml(context = {}) {
  const {
    state,
    isGrid,
    getFilteredCollectionsForShelf,
    createCollectionActionCardHtml,
    createCollectionCurrentCardHtml,
    createCollectionActionListItemHtml,
    createCollectionCurrentListItemHtml,
    createCollectionCardHtml,
    createCollectionListItemHtml
  } = context;

  if (state?.isSelectMode) return '';

  const collections = Array.isArray(state?.collections) ? state.collections : [];
  const pieces = [];

  if (state?.filterCollection !== 'all') {
    const current = collections.find(c => c && c.id === state.filterCollection) || null;
    if (isGrid) {
      pieces.push(createCollectionActionCardHtml('back', '返回书架'));
      if (current) pieces.push(createCollectionCurrentCardHtml(current));
    } else {
      pieces.push(createCollectionActionListItemHtml('back', '返回书架'));
      if (current) pieces.push(createCollectionCurrentListItemHtml(current));
    }
    return pieces.join('');
  }

  const visibleCollections = getFilteredCollectionsForShelf();
  if (visibleCollections.length === 0) return '';

  visibleCollections.forEach(col => {
    pieces.push(isGrid ? createCollectionCardHtml(col) : createCollectionListItemHtml(col));
  });

  return pieces.join('');
}

export function buildMixedShelfItems(context = {}) {
  const {
    state,
    filteredBooks,
    createCollectionCardHtml,
    createCollectionListItemHtml,
    createBookCard,
    createBookListItem,
    getFilteredCollectionsForShelf
  } = context;

  const isGridView = Boolean(state?.isGridView);
  const className = isGridView ? 'books-grid' : 'books-list';

  const visibleCollections = getFilteredCollectionsForShelf();
  const bookMap = new Map((state?.books || []).map(b => [String(b.id), b]));
  const membership = state?.collectionMembership || {};
  const collectionMetrics = new Map(visibleCollections.map(c => {
    const ids = Array.isArray(membership[c.id]) ? membership[c.id].map(String) : [];
    const lastRead = Math.max(0, ...ids.map(id => {
      const bk = bookMap.get(id);
      return bk?.lastReadAt ? new Date(bk.lastReadAt).getTime() : 0;
    }));
    const list = ids.map(id => bookMap.get(id)).filter(Boolean);
    const avgProgress = list.length
      ? list.reduce((acc, bk) => acc + (bk.progress || 0), 0) / list.length
      : 0;
    return [c.id, { lastReadAt: lastRead, progress: avgProgress }];
  }));

  const items = [
    ...(state?.shelfQuickFilter ? [] : visibleCollections.map(c => ({
      key: `collection:${c.id}`,
      type: 'collection',
      id: c.id,
      name: c.name || '',
      createdAt: c.createdAt || 0,
      lastReadAt: collectionMetrics.get(c.id)?.lastReadAt || 0,
      progress: collectionMetrics.get(c.id)?.progress || 0,
      sortOrder: (state?.collections || []).findIndex(x => x?.id === c.id),
      html: isGridView ? createCollectionCardHtml(c) : createCollectionListItemHtml(c)
    }))),
    ...((Array.isArray(filteredBooks) ? filteredBooks : []).map(b => ({
      key: `book:${b.id}`,
      type: 'book',
      id: b.id,
      name: b.title || '',
      createdAt: b.addedAt || 0,
      lastReadAt: b.lastReadAt ? new Date(b.lastReadAt).getTime() : 0,
      progress: b.progress || 0,
      sortOrder: typeof b.sortOrder === 'number' && Number.isFinite(b.sortOrder) ? b.sortOrder : Infinity,
      html: isGridView ? createBookCard(b) : createBookListItem(b)
    })))
  ];

  const byGlobal = new Map((state?.globalShelfOrder || []).map((k, i) => [k, i]));
  const sortedItems = [...items];

  switch (state?.sortBy) {
    case 'addedAt':
      sortedItems.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
      break;
    case 'lastReadAt':
      sortedItems.sort((a, b) => (b.lastReadAt || 0) - (a.lastReadAt || 0));
      break;
    case 'title':
      sortedItems.sort((a, b) => (a.name || '').localeCompare(b.name || '', 'zh-CN'));
      break;
    case 'progress':
      sortedItems.sort((a, b) => (b.progress || 0) - (a.progress || 0));
      break;
    case 'custom':
      sortedItems.sort((a, b) => {
        const ai = byGlobal.has(a.key) ? byGlobal.get(a.key) : Infinity;
        const bi = byGlobal.has(b.key) ? byGlobal.get(b.key) : Infinity;
        if (ai !== bi) return ai - bi;
        return a.sortOrder - b.sortOrder;
      });
      break;
  }

  if (sortedItems.length === 0) {
    return {
      className,
      html: `
        <div class="no-results">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"/>
            <path d="M21 21l-4.35-4.35"/>
          </svg>
          <p>未找到匹配的内容</p>
        </div>
      `
    };
  }

  return {
    className,
    html: sortedItems.map(it => it.html).join('')
  };
}
